<template>
  <button
    type="button"
    class="close-btn"
    v-bind="$attrs"
    :aria-label="$attrs['aria-label'] || 'Close'"
    @click="$emit('click')"
  >
    <close-icon :size="24" aria-hidden="true" />
  </button>
</template>

<script>
import CloseIcon from 'vue-material-design-icons/Close';

export default {
  inheritAttrs: false,
  components: {CloseIcon},
  name: 'closeButton',
};
</script>

<style lang="scss" scoped>
@use '@common/style/variables' as *;

.close-btn {
  background: transparent;
  border: 0;
  cursor: pointer;
  color: $neutral-600;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  opacity: 0.8;
  transition: all 0.2s ease;
  appearance: none;

  &:hover {
    opacity: 1;
  }

  &.dark {
    color: $text-color;
  }
}
</style>
